import { render } from "./EnableStaticNat.vue?vue&type=template&id=71839b6a&scoped=true"
import script from "./EnableStaticNat.vue?vue&type=script&lang=js"
export * from "./EnableStaticNat.vue?vue&type=script&lang=js"

import "./EnableStaticNat.vue?vue&type=style&index=0&id=71839b6a&scoped=true&lang=scss"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71839b6a"]])

export default __exports__